import * as React from 'react';
import { getInitialExerciseData } from '../../sample.utils';
import { BlogEditorReadOnlyWithStylesWithoutStore } from '@doltech/ui/lib/figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';

export const ExerciseEditorPreview = ({ detailData }) => {
  const exercise = React.useMemo(() => getInitialExerciseData(detailData)?.content, [detailData]);
  return <BlogEditorReadOnlyWithStylesWithoutStore key={exercise?.id} initialValue={exercise} />;
};
